import React from "react";
import styled from "@emotion/styled";
import { getSeverityColor } from "./improvementSeverity";

const LostMarksBar = ({ obtained, total }) => {
  const fraction = total > 0 ? obtained / total : 0;

  return (
    <Track>
      <Fill
        style={{
          width: `${Math.min(fraction * 100, 100)}%`,
          background: getSeverityColor(fraction),
        }}
      />
    </Track>
  );
};

const Track = styled.div`
  height: 5px;
  width: 100%;
  border-radius: 999px;
  background: #f1f2f4;
  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  border-radius: 999px;
`;

export default LostMarksBar;
